import { render, staticRenderFns } from "./TCC.vue?vue&type=template&id=68d12183&scoped=true&"
import script from "./TCC.vue?vue&type=script&lang=ts&"
export * from "./TCC.vue?vue&type=script&lang=ts&"
import style0 from "./TCC.vue?vue&type=style&index=0&id=68d12183&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d12183",
  null
  
)

export default component.exports